<ngx-spinner bdColor="rgba(0, 0, 0, 0.3)" size="default" color="#4d8ef7" type="line-scale-party"
[fullScreen]="true">
</ngx-spinner>
<router-outlet></router-outlet>
